<flowaccount-business-registration-ads-intro></flowaccount-business-registration-ads-intro>

<flowaccount-business-registration-ads-detail-list></flowaccount-business-registration-ads-detail-list>

<flowaccount-review-setion
  [bgColorTheme]="'blue-light-bg'"
  [customTextList]="reviewSectionTextList"
></flowaccount-review-setion>

<flowaccount-business-good-point
  [goodPointList]="goodPointList"
  [mockContent]="goodPoint"
></flowaccount-business-good-point>

<flowaccount-business-registration-ads-quickly-5-steps></flowaccount-business-registration-ads-quickly-5-steps>

<flowaccount-business-registration-ads-vdo-invite></flowaccount-business-registration-ads-vdo-invite>

<flowaccount-business-registration-ads-9-company></flowaccount-business-registration-ads-9-company>

<flowaccount-invite-to-use-section
  [customHeader]="customInviteSection"
  [customClassName]="'business-registration'"
  [customLink]="'https://form.flowaccount.com/th-th/businessregistrationservice'"
></flowaccount-invite-to-use-section>

<flowaccount-business-registration-ads-knowledge></flowaccount-business-registration-ads-knowledge>
